import { Component, effect, input, OnInit, output, ChangeDetectionStrategy } from '@angular/core';
import { MatCheckboxChange, MatCheckbox } from '@angular/material/checkbox';
import { IOption } from '@miq/shared-models';
import { TitleCasePipe } from '@angular/common';
import { L10nTranslationModule } from 'angular-l10n';
import { FormsModule } from '@angular/forms';
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'miq-sub-selection',
  templateUrl: './sub-selection.component.html',
  styleUrl: './sub-selection.component.scss',
  imports: [MatCheckbox, L10nTranslationModule, FormsModule, TitleCasePipe],
})
export class SubSelectionComponent implements OnInit {
  public selectAllFields = false;
  selectedFilter = input<string>();
  subSectionList = input<IOption[]>([]);
  InputLength = input<number>();
  editPermissionList = input<number[]>([]);
  selectedProperty = output<any>()
  public subSelectionArray: IOption[] = [];
  private editPermissionListInitialized = false;
  private subSectionListInitialized = false;
  constructor() {
    effect(() => {
      const epl = this.editPermissionList();
      if (!this.editPermissionListInitialized) {
        this.editPermissionListInitialized = true;
        return;
      }
      if (epl && epl.length > 0) {
        this.runInitLogic();
      }
    });
    effect(() => {
      const ssl = this.subSectionList();
      if (!this.subSectionListInitialized) {
        this.subSectionListInitialized = true;
        return;
      }
      if (ssl && ssl.length > 0) {
        this.runInitLogic();
      }
    });
  }
  ngOnInit() {
    this.runInitLogic();
  }
  private runInitLogic() {
    if (this.editPermissionList() && this.subSectionList()) {
      this.subSectionList().forEach(item => {
        if (this.editPermissionList().includes(item.key)) {
          item.checked = true;
          this.subSelectionArray.push(item);
        }
      });
      this.selectAllFields = this.subSectionList().every(item => item.checked) ? true : false;
    }
  }
  public onSelectionChange(item, event) {
    if (event.checked) {
      this.subSelectionArray.push(item);
    } else {
      this.selectAllFields = false;
      this.subSelectionArray.forEach((geoLocation, index) => {
        if (geoLocation.key === item.key) {
          this.subSelectionArray.splice(index, 1);
        }
      });
    }
    this.selectedProperty.emit(this.subSelectionArray);
  }
  public selectAll(evt: MatCheckboxChange) {
    const { checked: isChecked } = evt;
    this.subSelectionArray = [];
    this.subSectionList().forEach(object => {
      object.checked = isChecked;
    });
    this.selectAllFields = isChecked;
    if (isChecked) {
      this.subSelectionArray = JSON.parse(JSON.stringify(this.subSectionList()));
      this.selectedProperty.emit(this.subSelectionArray);
    } else {
      this.selectedProperty.emit([]);
    }
  }
}
